import DangerousIcon from "@mui/icons-material/Dangerous";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Badge, Card, CardActionArea, IconButton } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PacmanLoader from "react-spinners/PacmanLoader";
import { backendApi } from "../../../app/services/backendApi";

import { addToListLevels, addToListServices, setCount, setStartResearch } from "../../../features/display/displaySlice";
import { useState } from "react";

import styles from "../../../styles/cardService.module.css";
/* ------------------------------------------------------------------------- */

const CardService = ({ props }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const duration = 86400; //24h
  const defaultDuration = 1800; // period in seconds: 1800 for 30 minutes, 84600 for 1 day

  const [triggerCountError, responseCountError] = backendApi.endpoints.getLogsByService.useLazyQuery();
  const [triggerCountWarning, responseCountWarning] = backendApi.endpoints.getLogsByService.useLazyQuery();
  const [triggerCountInfo, responseCountInfo] = backendApi.endpoints.getLogsByService.useLazyQuery();

  const [triggerService, responseService] = backendApi.endpoints.getAllInfoByService.useLazyQuery();

  const [countInfo, setCountInfo] = useState();
  const [countWarning, setCountWarning] = useState();
  const [countError, setCountError] = useState();

  const [statusServ, setStatusServ] = useState("goodStatus");

  const [lastError, setLastError] = useState(null);
  const [lastWarning, setLastWarning] = useState(null);
  const [lastInfo, setLastInfo] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  /* ------------------------------------------------------------------------- */

  let pError = {
    service: props.name,
    duration: duration,
    criticite: 3
  };

  let pWarning = {
    service: props.name,
    duration: duration,
    criticite: 2
  };

  let pInfo = {
    service: props.name,
    duration: duration,
    criticite: 1
  };

  let param = {
    service: props.name,
    duration: defaultDuration
  };

  /* ------------------------------------------------------------------------- */

  useEffect(() => {
    triggerService(param);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const interval = setInterval(
      () => {
        triggerCountError(pError);
        triggerCountWarning(pWarning);
        triggerCountInfo(pInfo);
      },
      15 * 60 * 1000
    );
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (responseCountError.status === "fulfilled" && responseCountError.data?.success) {
      setCountError(responseCountError?.data?.nbresultats || 0);
    }
    if (responseCountInfo.status === "fulfilled" && responseCountInfo.data?.success) {
      setCountInfo(responseCountInfo?.data?.nbresultats || 0);
    }
    if (responseCountWarning.status === "fulfilled" && responseCountWarning.data?.success) {
      setCountWarning(responseCountWarning?.data?.nbresultats || 0);
    }
  }, [responseCountError, responseCountInfo, responseCountWarning]);

  useEffect(() => {
    triggerCountError(pError);
    triggerCountWarning(pWarning);
    triggerCountInfo(pInfo);

    if (responseService.status === "fulfilled" && responseService.isSuccess) {
      const info = responseService.data?.infosService?.[0];
      setLastError(info?.lastErrorLog || null);
      setLastWarning(info?.lastWarningLog || null);
      setLastInfo(info?.lastInfoLog || null);
      setIsDataLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseService.data]);

  // Set the status of the service based on the last error, warning and info
  // define consequently the Icon to display
  useEffect(() => {
    if (!isDataLoaded) {
      return;
    }
    if (lastWarning == null && lastError == null) {
      setStatusServ("goodStatus");
    }

    if (lastWarning !== null && lastError == null) {
      setStatusServ("warningStatus");
    }

    if (lastError !== null) {
      setStatusServ("errorStatus");
    }
  }, [lastError, lastWarning, lastInfo, isDataLoaded]);

  let imageService = require("/src/assets/img/cards/" + props.image_file);

  // - functions --------------------------------------------------------------
  const handleClickCard = (parameter) => {
    dispatch(addToListServices(parameter.name));
    let criticite = lastError !== null ? 3 : lastWarning !== null ? 2 : 1;
    dispatch(addToListLevels(criticite));
    dispatch(setStartResearch(true));
    navigate("/monitoring");
  };

  const handleClickSuccess = (parameter) => {
    navigate("/monitoring");

    setTimeout(() => {
      dispatch(addToListServices(parameter.name));
      let criticite = 1;
      dispatch(addToListLevels(criticite));
      dispatch(setCount(true));
    }, 0);
  };

  const handleClickWarning = (parameter) => {
    navigate("/monitoring");

    setTimeout(() => {
      dispatch(addToListServices(parameter.name));
      let criticite = 2;
      dispatch(addToListLevels(criticite));
      dispatch(setCount(true));
    }, 0);
  };
  const handleClickError = (parameter) => {
    navigate("/monitoring");

    setTimeout(() => {
      dispatch(addToListServices(parameter.name));
      let criticite = 3;
      dispatch(addToListLevels(criticite));
      dispatch(setCount(true));
    }, 0);
  };

  // - Interval useEffect to update data each 30 seconds ----------------------
  useEffect(() => {
    const interval = setInterval(() => {
      triggerService(param);
    }, 30000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // - Display content --------------------------------------------------------
  return (
    <>
      <div className={statusServ === "goodStatus" ? styles.goodStatus : statusServ === "warningStatus" ? styles.warningStatus : statusServ === "errorStatus" ? styles.errorStatus : styles.unactiveStatus}>
        <div className={styles.contentCard}>
          <Card
            sx={{ maxWidth: 280 }}
            className={styles.cardService}
            onClick={(e) => {
              handleClickCard(props, e);
            }}
          >
            <div className={styles.imgCard}>
              <div className={styles.serviceLbl}>{props.surname}</div>
              <CardActionArea>
                <CardMedia component="img" height="140" width="100" image={imageService} alt={props.name} />
                <CardContent className={styles.contentInfos}>
                  {!responseService.isLoading ? (
                    <>
                      <div className={`${styles.statusImgBlock}`}>
                        {statusServ === "goodStatus" ? (
                          <TaskAltIcon className={styles.colorGreen} />
                        ) : statusServ === "warningStatus" ? (
                          <WarningAmberIcon className={styles.colorOrange} />
                        ) : statusServ === "errorStatus" ? (
                          <DangerousIcon className={styles.colorRed} />
                        ) : (
                          <RotateRightIcon className={styles.colorGray} />
                        )}
                      </div>
                      <div className={styles.logInfo}>
                        <>
                          {lastError !== null ? lastError : lastWarning !== null ? lastWarning : lastInfo !== null ? lastInfo : "aucun"}
                          <br />
                        </>
                      </div>
                    </>
                  ) : (
                    <div className={styles.logSpinner}>
                      <PacmanLoader size={10} />
                    </div>
                  )}
                </CardContent>
              </CardActionArea>
            </div>
          </Card>
          <div className={styles.counts}>
            {countInfo >= 0 ? (
              <div className={styles.count}>
                <IconButton>
                  <Badge
                    className={styles.counterBadge}
                    color="success"
                    showZero
                    max={999}
                    badgeContent={countInfo}
                    onClick={(e) => {
                      handleClickSuccess(props, e);
                    }}
                  />
                </IconButton>
              </div>
            ) : (
              <></>
            )}
            {countWarning >= 0 ? (
              <div className={styles.count}>
                <IconButton>
                  <Badge
                    className={styles.counterBadge}
                    color="warning"
                    showZero
                    max={999}
                    badgeContent={countWarning}
                    onClick={(e) => {
                      handleClickWarning(props, e);
                    }}
                  />
                </IconButton>
              </div>
            ) : (
              <></>
            )}
            {countError >= 0 ? (
              <div className={styles.count}>
                <IconButton>
                  <Badge
                    className={styles.counterBadge}
                    color="error"
                    showZero
                    max={999}
                    badgeContent={countError}
                    onClick={(e) => {
                      handleClickError(props, e);
                    }}
                  />
                </IconButton>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CardService;
